import * as React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import ReportIcon from '@material-ui/icons/Report';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  createPermitFeesComment,
  deletePermitFees,
  getPermitsFeesStatistics,
  getUnpaidPermitsFees,
  updatePermitFees,
} from '../../api/fees';
import { getProjectByID } from '../../api/projects';
import PermitFeesForm from '../../forms/PermitFeeForm/PermitFeesForm';

import useTablePage from '../../hooks/useTablePage';
import { ModalDefaultDraggable } from '../../molecules';
import ModalInfo from '../../molecules/ModalInfo';
import ContactNotAvailableModal from '../../molecules/ContactNotAvailableModal';
import Table from '../../organisms/Table';
import { convertTableBoolean } from '../../utils/convertTableValues';
import tableColumnsFormatter from '../../utils/tableColumnsFormatter';
import FeesSendModal from '../../organisms/FeesSendModal';
import { getPermitUsers } from '../../api/users';
import {
  DEFAULT_DATE_FORMAT,
} from '../../constants';
import formatDate from '../../utils/formatDate';
import { getCustomActivities } from '../../api/activities';
import { RootState } from '../../redux/root';
import { setPermitContacts } from '../../redux/slices/projectSlice';
import { setDeleteError, setPermitFees, setPermitFeesToManualyPay, setShowDeleteMessage } from '../../redux/slices/feesSlice';
import { viewInvoice } from '../../Components/InvoiceTool/InvoiceUtil';
import useShowInvoicePdf from '../../Components/InvoiceTool/useShowInvoicePdf';
import InvoiceTool from '../../Components/InvoiceTool/InvoiceTool';
import { InvoiceWrapper } from '../../forms/FeesSendForm';
import FeeDeletePopup from './FeeDeletePopup';
import { api } from '../../api/api';
import { ButtonMain } from '../../atoms';

export const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

const FeesPage = ({
  permit,
  isAddFees,
  setAddFees,
  setFeeSelected,
  isSendingSelectedFees,
  setIsSendingSelectedFees,
  cameFromSearch,
}: Props) => {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const permitContacts = useSelector((s:RootState) => s.projectsSlice.permitContacts);
  const pulse = useSelector((s:RootState) => s.general.pulse);
  const [
    selectedTableFees,
    _setSelectedTableFees,
  ] = React.useState([]);

  const setSelectedTableFees = fees => {
    const notCompleted = fees.filter(a => a.status !== 'Completed');
   _setSelectedTableFees(notCompleted);
  };

  const [
    selectedFeesIds,
    setSelectedFeesIds,
  ] = React.useState([]);

  const [
    projectJurisdiction,
    setProjectJurisdiction,
  ] = React.useState(null);
  const [totalInvoices, setTotalInvoices] = React.useState(
    0,
  );
  const [
    totalOutstanding,
    setTotalOutstanding,
  ] = React.useState(0);

  const [
    isOpenFeesSendModal,
    setOpenFeesSendModal,
  ] = React.useState(false);
  const [deleteFeeId, setDeleteFeeId] = useState();
  const [feeName, setFeeName] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const [
    isPaidManuallySubmit,
    setIsPaidManuallySubmit,
  ] = React.useState(false);
  const { invoicePdf, invoiceNumber, hasViewClicked } = useSelector((s:RootState) => s.fees);
  const { handleInvoiceCellClick: hicc, reimbursableAttachment } = useShowInvoicePdf(selectedFeesIds);
  const handleInvoiceCellClick = arg => {
     hicc(arg);
  };
  const {
    tableManuallyUpdate,
    updateTable,
    search,
    handleEdit: he,
    isModalOpen,
    createOrUpdate,
    modalSuccess,
    modalError,
    modalTitle,
    modalErrorTitle,
    errors,
    values,
    handleCloseModalInfo,
    handleCloseModal,
    handleAdd,
    showSuccessModal,
  } = useTablePage({
    updateEndpoint: updatePermitFees,
    createEndpoint: createPermitFeesComment,
    modalCreateTitle: 'Add Fees',
  });
const [popupValue, setPopupValues] = useState();
const handleEdit = a => {
  setPopupValues(a);
  he(a);
};
  useEffect(() => {
    if (pulse > 0) {
      updateTable();
      const load = async () => {
        const paymentDetails = await getUnpaidPermitsFees({ permit });
        setTotalOutstanding(paymentDetails.data.totalUnpaidFees);
      };
      load();
      setTimeout(() => {
        dispatch(setPermitFeesToManualyPay([]));
      }, 5000);
    }
  }, [pulse]);

  React.useEffect(() => {
    if (permit) {
      Promise.all([
        getPermitUsers({
          user_role: 3,
          permit_id: permit,
        }),
      ])
        .then(
          ([
            permitUsers,
          ]) => {
              const contacts = permitUsers?.data;
            dispatch(setPermitContacts(contacts));
          },
        )
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    }
  }, [permit]);

  React.useEffect(() => {
    if (
      isSendingSelectedFees &&
      Array.isArray(selectedTableFees) &&
      selectedTableFees?.length
    ) {
      setOpenFeesSendModal(true);
    }
  }, [isSendingSelectedFees]);

  React.useEffect(() => {
    if (!isOpenFeesSendModal) {
      setIsSendingSelectedFees(false);
    }
  }, [isOpenFeesSendModal]);

  React.useEffect(() => {
    if (Array.isArray(selectedTableFees)) {
      if (selectedTableFees?.length) {
        const sentOrPaidFees = selectedTableFees.filter(
          fee =>
            fee.status === 'Sent' || fee.status === 'Paid' || fee.status === 'Void' || fee.status === 'Paid by Another Method' || fee.status === 'Invoiced in QB',
        );
        if (sentOrPaidFees.length) {
          setSelectedFeesIds([]);
          setFeeSelected(false);
        }
        if (!sentOrPaidFees.length) {
          setFeeSelected(true);
          setSelectedFeesIds(
            selectedTableFees?.map(fee => fee?.id),
          );
        }
      }
      if (!selectedTableFees?.length) {
        setSelectedFeesIds([]);
        setFeeSelected(false);
      }
    }
    const sentItemsToBeManuallyPaid = selectedTableFees.filter(s => s.status === "Sent");
    if (sentItemsToBeManuallyPaid && sentItemsToBeManuallyPaid.length > 0) {
      dispatch(setPermitFeesToManualyPay(sentItemsToBeManuallyPaid));
    }
  }, [selectedTableFees]);

  React.useEffect(() => {
    if (projectId) {
      Promise.all([getProjectByID(projectId)]).then(
        ([projectResponse]) => {
          setProjectJurisdiction(
            projectResponse.data?.jurisdiction,
          );
        },
      );
    }
  }, [projectId]);

  React.useEffect(() => {
    if (isAddFees) {
      handleAdd();
    }
  }, [isAddFees]);

  React.useEffect(() => {
    updateTable();
  }, [modalSuccess, modalError]);

  React.useEffect(() => {
    if (invoicePdf) {
      viewInvoice(invoicePdf, invoiceNumber, hasViewClicked, dispatch);
    }
  }, [invoicePdf]);

  const closeInfoModal = () => {
    updateTable();
    handleCloseModalInfo();
  };

  const columns = column => {
    if (
      [
        'permit',
        'creator',
        'feeSettings',
        'feeCheckbox',
        'invoiceId',
        'isPaidManual',
        'type',
        'isVoid',
        'createdAt',
        'createdBy',
        'completedAt',
        'completedBy',
        'notes',
        'invoicePdf',
        'file',
        'fileName',
        'fullInvoiceNumber',
        'feePaidAt',
        'isCompleted',
        'isDeleted',
      ].includes(column)
    ) {
      return null;
    }

    switch (column) {
      case 'id':
        return 'ID';
      case 'name':
        return 'Fee Name';
      case 'amount':
        return 'Amount';
      case 'quantity':
        return 'Quantity';
      case 'total':
        return 'Total';
      case 'status':
        return 'Status';
      case 'dateInvoiced':
        return 'Date Invoiced';
      case 'datePaid':
        return 'Date Paid';
      case 'lastComment':
        return 'Comments';
      case 'invoiceNumber':
        return 'Invoice Number';
      case 'invoicePdf':
        return 'Invoice';
      case 'createdAt':
        return 'Date Created';
      // case 'completedAt':
      //   return 'Date Completed'
      default:
        return tableColumnsFormatter(column);
    }
  };

  const columnsOrder = [
    'id',
    'invoiceNumber',
    'name',
    'amount',
    'quantity',
    'total',
    'status',
    'dateInvoiced',
    'datePaid',
    'invoicePdf',
    'lastComment',
    'createdAt',
    'createdBy',
    // 'completedAt',
    // 'completedBy'
  ];

  const getDatePaid = fee => {
    if (fee.datePaid) {
      return formatDate(
        fee.datePaid,
        DEFAULT_DATE_FORMAT,
      );
    }

    if (fee.feePaidAt) {
      return formatDate(
        new Date(fee.feePaidAt),
        DEFAULT_DATE_FORMAT,
      );
    }

    return '';
  };
  const modifiedGetPermitFees = params =>
    Promise.all([
      // getPermitsFees({
      //   ...params,
      //   permit,
      // }),
      getCustomActivities({
        ...params,
        // permit,
        permit_id: permit,
        event_type: "Activity",
        activity_type_name: "Fee",
        sort_by: params?.ordering,
        ordering: null,
      }),
      getPermitsFeesStatistics({
        ...params,
        permit,
      }),
      getUnpaidPermitsFees({ permit }),
    ])
      .then(([feesResponse, feesStatistics, paymentDetails]) => {
        setTotalOutstanding(feesStatistics.data.outstanding
          ? feesStatistics.data.outstanding
          : 0);
        setTotalInvoices(
          feesStatistics.data.totalInvoiced
            ? feesStatistics.data.totalInvoiced
            : 0,
        );
        dispatch(setPermitFees(feesResponse.data.results));
        const getCleanInvoice = invoiceNumber => {
          if (invoiceNumber && invoiceNumber.indexOf('----') > -1) {
            return invoiceNumber.split('----')[0];
          }
          return invoiceNumber;
        };
        return {
          ...feesResponse,
          data: {
            ...feesResponse.data,
            results: feesResponse.data.results.map(fee => {
              return {
                ...fee,
                invoiceNumber: getCleanInvoice(fee.invoiceNumber),
                fullInvoiceNumber: fee.invoiceNumber,
                dateInvoiced: fee.dateInvoiced
                  ? formatDate(
                      fee.dateInvoiced,
                      DEFAULT_DATE_FORMAT,
                    )
                  : fee.dateInvoiced,
                datePaid: getDatePaid(fee),
                amount: currencyFormat.format(+fee.amount),
                total: currencyFormat.format(+fee.total),
                lastComment: fee?.lastComment?.replace(
                  /(<([^>]+)>)/gi,
                  ' ',
                ),
                invoicePdf: fee?.invoicePdf
                  ? `${window.location.origin}${fee?.invoicePdf}`
                  : '',
              };
            }),
          },
        };
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
      .finally(() => {});

  const handleCloseFeesModal = () => {
    if (!modalError && !modalSuccess && !isPaidManuallySubmit) {
      setAddFees(false);
      handleCloseModal();
      updateTable();
    }
  };

  const handleTableFeeSelect = fees => {
    setSelectedTableFees(fees);
  };

  const cellCallbackFnIsOn = ['invoiceNumber'];

  const onDelete = e => {
    if (e.status === 'Pending') {
      setDeleteModalOpen(true);
      setDeleteFeeId(e.id);
      setFeeName(e.name);
    } else {
      dispatch(setDeleteError(true));
      dispatch(setShowDeleteMessage(true));
    }
  };

  const handleDeleteReport = e => {
    const performDelete = async id => {
      const res = await deletePermitFees(id);
      setDeleteModalOpen(false);
      setShowSuccess(true);
      updateTable();
    };
    performDelete(deleteFeeId);
  };
  return (
    <>
      {showSuccess && <ModalInfo
        title="Success"
        timeToClose={5000}
        isError={modalError}
        onClose={() => setShowSuccess(false)}
        errorMsg={modalErrorTitle}
      />}
      {deleteModalOpen && (
      <ModalDefaultDraggable
        title="Are you sure you want to delete?"
        onClose={() => setDeleteModalOpen(false)}
      >
        <>
          <ModalMessage>
            {`Fee ID: ${deleteFeeId} - ${feeName}`}
          </ModalMessage>
          <Icon>
            <ReportIcon />
          </Icon>
          <br />

          <ButtonContainer>
            <ButtonMain color="secondary" onClick={handleDeleteReport}>
              Yes, delete
            </ButtonMain>
            <ButtonMain color="default" onClick={() => setDeleteModalOpen(false)}>
              No
            </ButtonMain>
          </ButtonContainer>
        </>
      </ModalDefaultDraggable>
        )}
      <FeeDeletePopup />
      <InvoiceWrapper>
        <InvoiceTool fees={selectedFeesIds} reimbursableAttachment={reimbursableAttachment} />
      </InvoiceWrapper>

      <h3>
        Total invoiced:{' '}
        <StyledNumber>
          {currencyFormat.format(totalInvoices)}
        </StyledNumber>
      </h3>
      <h3>
        Outstanding:{' '}
        <StyledNumber>
          {currencyFormat.format(totalOutstanding)}
        </StyledNumber>
      </h3>
      <Table
        customSearch
        initialUseSortBy
        permitFeesTable
        searchQuery={search}
        columns={columns}
        columnsOrder={columnsOrder}
        rows={modifiedGetPermitFees}
        onEdit={handleEdit}
        onDelete={onDelete}
        onConfigure={null}
        formatValue={convertTableBoolean}
        manuallyUpdate={tableManuallyUpdate}
        onSelect={handleTableFeeSelect}
        handleCellClick={handleInvoiceCellClick}
        cellCallbackFnIsOn={cellCallbackFnIsOn}
        feesTable
        useViewModeInsteadEdit={cameFromSearch}
      />

      {isOpenFeesSendModal && (
        <FeesSendModal
          permit={permit}
          fees={selectedFeesIds}
          contacts={permitContacts}
          isOpenFeesSendModal={isOpenFeesSendModal}
          setOpenFeesSendModal={setOpenFeesSendModal}
          updateTable={updateTable}
          setSelectedTableFees={setSelectedTableFees}
        />
      )}
      {isModalOpen && (
        <ModalDefaultDraggable
          title={modalTitle}
          onClose={handleCloseFeesModal}
        >
          <PermitFeesForm
            onSubmit={createOrUpdate}
            initialValues={values}
            selectedFee={popupValue}
            modalError={modalError}
            addButtonText="Create"
            updateButtonText="Update"
            initialErrors={errors}
            permit={permit}
            jurisdiction={projectJurisdiction}
            handleCloseModal={handleCloseFeesModal}
            showSuccessModal={showSuccessModal}
            cameFromSearch={cameFromSearch}
            // isPaidManuallySubmit={isPaidManuallySubmit}
            setIsPaidManuallySubmit={setIsPaidManuallySubmit}
            updatePermitFeesTable={updateTable}
          />
        </ModalDefaultDraggable>
      )}
      {isModalOpen && (
        <ContactNotAvailableModal key={values?.id} record={values} />
      )}
      {(modalSuccess || modalError) && (
        <ModalInfo
          timeToClose={5000}
          isError={modalError}
          onClose={closeInfoModal}
          errorMsg={modalErrorTitle}
        />
      )}
    </>
  );
};

interface Props {
  permit: number;
  isAddFees: boolean;
  isSendingSelectedFees: boolean;
  setAddFees: (data: boolean) => void;
  setIsSendingSelectedFees: (data: boolean) => void;
  setFeeSelected: (data: boolean) => void;
  cameFromSearch?:boolean;
  isPaidManuallySubmit: boolean;
  setIsPaidManuallySubmit: (data: boolean) => void;
}

const StyledNumber = styled.span`
  color: var(--primary);
`;

const Icon = styled.div`
  position: relative;
  left: 138px;
  top: -76px;
  color: red;
  width: fit-content;
  svg {
    scale: 1.5;
  }
`;

const ModalMessage = styled.div`
 width:100%;
 text-align: center;
 font-weight: bold;
`;

const ButtonContainer = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;

  > .MuiButton-root {
    margin: 0 20px 0 0;

    &:last-child {
      margin: 0;
    }
  }
`;
export default FeesPage;
